import React, { useMemo, useState } from 'react'
import { quoteRequests } from '../data/mockData'
import { Card, PageTitle, SearchField, StatusBadge, formatCurrency, formatDate } from '../components/Ui'

export default function QuoteRequests({ navigate }) {
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const filtered = useMemo(() => quoteRequests.filter((item) => {
    const text = [item.requestNo, item.customer?.name, item.customer?.nickname, item.supportType, item.artist, item.region].join(' ').toLowerCase()
    return (!search || text.includes(search.toLowerCase())) && (status === 'ALL' || item.status === status)
  }), [search, status])

  return (
    <>
      <PageTitle eyebrow="QUOTE REQUESTS" title="견적 요청 관리" description="고객 요청 원문, AI 구조화 결과, 디렉터 전달·응답 상태를 확인합니다." />
      <Card className="table-card">
        <div className="table-toolbar">
          <SearchField value={search} onChange={setSearch} placeholder="요청번호, 고객, 서비스, 지역 검색" />
          <div className="filter-buttons">
            {[['ALL','전체'],['ANALYZED','분석 완료'],['DISTRIBUTED','전달 완료'],['RECEIVING_QUOTES','견적 수신 중'],['SELECTED','선택 완료']].map(([value,label]) => <button key={value} className={status === value ? 'active' : ''} onClick={() => setStatus(value)}>{label}</button>)}
          </div>
        </div>
        <div className="table-result-bar"><span>총 <strong>{filtered.length}</strong>건</span><small>AI 분석 실패 시 요청 자체는 유지하고 rule-based fallback</small></div>
        <div className="table-scroll"><table className="data-table"><thead><tr><th>요청번호</th><th>고객</th><th>서비스 / 행사</th><th>지역</th><th>예산</th><th>전달/견적</th><th>상태</th><th>요청일</th><th /></tr></thead><tbody>{filtered.map((item) => <tr key={item.id} onClick={() => navigate(`/quote-requests/${item.id}`)}><td><strong>{item.requestNo}</strong></td><td><strong>{item.customer?.nickname || item.customer?.name}</strong><small>{item.customer?.name}</small></td><td><strong>{item.supportType}</strong><small>{item.artist}</small></td><td>{item.region}</td><td>{formatCurrency(item.budgetMin)}<small>~ {formatCurrency(item.budgetMax)}</small></td><td>{item.distributedDirectorCount}명 / {item.quoteCount}건</td><td><StatusBadge status={item.status} /></td><td>{formatDate(item.submittedAt, true)}</td><td><button className="row-arrow">›</button></td></tr>)}</tbody></table></div>
      </Card>
    </>
  )
}
